// Shared browser DOM helpers for the portal client.
//
// The rail and the feed each ship a block of encapsulated CSS. Injecting it
// against the mounted container's *root node* is what lets the same modules run
// two ways: mounted directly in the page (root = the document, styles land in
// `<head>`) or mounted inside an embed's Shadow DOM (root = the shadow root,
// styles land in the shadow — encapsulated both directions). The `id` guard
// keeps it to one `<style>` per root no matter how many rails/feeds share it.

/** Inject `css` under `id` into the style root of `container`, once per root. */
export function injectStyles(container: Node, id: string, css: string): void {
  const root = container.getRootNode();
  const host = root instanceof ShadowRoot ? root : document.head;
  if (host.querySelector(`#${id}`)) return;
  const style = document.createElement("style");
  style.id = id;
  style.textContent = css;
  host.appendChild(style);
}
